import React, { useEffect, useState } from 'react'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import companyService from '../../services/data/company.service'
import currencyFormat from '../../helpers/currencyFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown'

const STATUS_BADGE = {
    dentro: <span className='badge bg-success'>Dentro</span>,
    acima: <span className='badge bg-danger'>Acima</span>,
    abaixo: <span className='badge bg-warning text-dark'>Abaixo</span>,
    sem_estrutura: <span className='badge bg-secondary'>Sem estrutura</span>,
    sem_dados: <span className='badge bg-light text-muted border'>Sem dados</span>,
}

function BudgetBadge({ pct }) {
    if (pct === null || pct === undefined) return <span className='badge bg-secondary'>Sem orçamento</span>
    if (pct >= 100) return <span className='badge bg-danger'>Acima do orçamento</span>
    if (pct >= 90) return <span className='badge bg-warning text-dark'>Próximo do limite</span>
    return <span className='badge bg-success'>Dentro do orçamento</span>
}

export default function AnaliseDepartamento() {
    const [departments, setDepartments] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [expandedDept, setExpandedDept] = useState(null)
    const [subcompanySel, setSubcompanySel] = useState(null)
    const [subcompanyItems, setSubcompanyItems] = useState([])

    function loadData(filters = {}) {
        setLoading(true)
        setError('')
        salaryAnalysisService.listDepartamentos(filters)
            .then(setDepartments)
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }

    useEffect(() => { loadData() }, [])
    useEffect(() => {
        companyService.autoCompleteSubCompany('')
            .then(r => setSubcompanyItems(r || []))
            .catch(() => setSubcompanyItems([]))
    }, [])

    function applyFilters() {
        const f = {}
        if (subcompanySel) f.subcompany_id = subcompanySel.id
        loadData(f)
    }

    function clearFilters() {
        setSubcompanySel(null)
        loadData()
    }

    function toggleDept(deptId) {
        setExpandedDept(expandedDept === deptId ? null : deptId)
    }

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Análise por Departamento</span>
                        </div>

                        {/* Filtros */}
                        <div className='row m-3 g-2 align-items-end'>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Organização</label>
                                <Dropdown className='w-100' placeholder='Filtrar por organização'
                                    value={subcompanySel}
                                    options={subcompanyItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setSubcompanySel(e.value)} />
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-success btn-sm' onClick={applyFilters}>
                                    <FontAwesomeIcon icon={solid('magnifying-glass')} /> Filtrar
                                </button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-link btn-sm text-grey text-decoration-none' onClick={clearFilters}>Limpar</button>
                            </div>
                        </div>

                        {error && <div className='alert alert-danger mx-3'>{error}</div>}

                        {loading && (
                            <div className='text-center p-5'>
                                <div className="spinner-border text-success" role="status" />
                            </div>
                        )}

                        {!loading && departments.length === 0 && (
                            <p className='text-center text-muted p-5'>Nenhum departamento encontrado.</p>
                        )}

                        {!loading && departments.length > 0 && (
                            <div className='row m-3 g-3'>
                                {departments.map(dept => {
                                    const isExpanded = expandedDept === dept.department_id
                                    const pct = dept.budget_used_pct
                                    return (
                                        <div key={dept.department_id} className='col-md-6 col-xl-4'>
                                            <div className='card border-clean h-100'>
                                                <div className='card-body'>
                                                    <div className='d-flex justify-content-between align-items-start'>
                                                        <div>
                                                            <h6 className='fw-bold mb-0'>{dept.department_title}</h6>
                                                            <small className='text-muted'>{dept.department_code}</small>
                                                        </div>
                                                        <BudgetBadge pct={pct} />
                                                    </div>
                                                    <hr className='my-2' />
                                                    <div className='row text-center g-2 mb-2'>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Posições</div>
                                                            <div className='fw-bold'>{dept.total_expected_positions}</div>
                                                        </div>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Alocados</div>
                                                            <div className='fw-bold text-success'>{dept.total_headcount}</div>
                                                        </div>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Massa Sal.</div>
                                                            <div className='fw-bold small'>{currencyFormat(dept.total_salary_mass)}</div>
                                                        </div>
                                                    </div>

                                                    {pct !== null && (
                                                        <div className='mb-2'>
                                                            <div className='d-flex justify-content-between small mb-1'>
                                                                <span>Orçamento utilizado</span>
                                                                <span className='fw-bold'>{pct}%</span>
                                                            </div>
                                                            <div className='progress' style={{height: 6}}>
                                                                <div
                                                                    className={`progress-bar ${pct >= 100 ? 'bg-danger' : pct >= 90 ? 'bg-warning' : 'bg-success'}`}
                                                                    style={{width: `${Math.min(pct, 100)}%`}}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <button className='btn btn-sm btn-link text-green text-decoration-none p-0'
                                                        onClick={() => toggleDept(dept.department_id)}>
                                                        <FontAwesomeIcon icon={isExpanded ? solid('chevron-up') : solid('chevron-down')} className='me-1' />
                                                        {isExpanded ? 'Ocultar posições' : `Ver ${dept.positions.length} posições`}
                                                    </button>

                                                    {isExpanded && dept.positions.length > 0 && (
                                                        <div className='mt-2'>
                                                            <table className='table table-sm table-borderless'>
                                                                <thead className='borderBottom'>
                                                                    <tr className='small'>
                                                                        <th>Cargo</th>
                                                                        <th className='text-center'>Aloc.</th>
                                                                        <th className='text-end'>Média</th>
                                                                        <th className='text-center'>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {dept.positions.map((pos, i) => (
                                                                        <tr key={i} className='small'>
                                                                            <td>{pos.internaljobtitle?.title || pos.title}</td>
                                                                            <td className='text-center'>{pos.headcount}</td>
                                                                            <td className='text-end'>
                                                                                {pos.avg_real_salary !== null ? currencyFormat(pos.avg_real_salary) : '-'}
                                                                            </td>
                                                                            <td className='text-center'>
                                                                                {STATUS_BADGE[pos.salary_status]}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
